import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { MenuService } from '../shared/app.menu.service';
import { PatientService } from "../../../services/patient.service";
import { Router } from '@angular/router';
import { Title } from "@angular/platform-browser";
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { URLS } from 'src/app/constant/constant';

import { ENV_URLS } from 'src/environments/environment';

@Component({
    selector: 'app-patient-dashboard',
    templateUrl: './patient-dashboard.component.html',
    styleUrls: ['../../../../assets/css/custom-egd.css', './patient-dashboard.component.css']
})
@TraceClassDecorator()
export class PatientDashboardComponent implements OnInit, OnDestroy {

    //globals = Globals;
    subscription: Subscription;
    name: string;
    email: string;
    RefreshToken: string;
    Activated: boolean;
    Membership_data: string = "Activate Membership";
    is_primary_provider: boolean = false;
    notifications: number = 78;
    userid: string;
    user: any;
    is_uk_country: boolean = false;
    layoutMode = 'static';

    megaMenuMode = 'dark';

    menuMode = 'gradient';

    profileMode = 'top';

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    menuHoverActive: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    megaMenuActive: boolean;

    megaMenuClick: boolean;

    usermenuActive: boolean;

    usermenuClick: boolean;

    activeProfileItem: any;

    slug: string = "";

    constructor(
        private readonly router: Router,
        private readonly titleService: Title,
        public renderer: Renderer2,
        private readonly menuService: MenuService,
        private readonly patientservice: PatientService,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly userservice: UserService,
        private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService

    ) {
        this.breadcrumbService.setItems([
            // { label: 'Patient Dashboard' },
            // { label: 'Dashboard', routerLink: ['/patient'] },
        ]);

        /*     this.subscription = communicationService.userHandler.subscribe(response => {
                this.user = response;

            }); */

    }

    async CheckifUserGuidisCorrect(user_guid: string) {


        await this.userservice.UserCheck(user_guid).toPromise().then(result => {
            if (!result.success) {
                this.router.navigate(['/' + this.slug + '/accessdenied']);
            }
            else {
                if (!result.data.user_exist) {
                    this.router.navigate(['/' + this.slug + '/accessdenied']);

                }
            }
        }).catch(err => console.info(err));


    }

    CheckifMemberExists(): void {
        this.patientservice.getMember(this.userid).toPromise().then(result => {
            if (!result.success) {
                //do something here
                this.Activated = false;
            }
            else {
                if (result.data != null && result.data.patient != null && result.data.patient.length > 0) {
                    this.Activated = true;
                }
                else {
                    this.Activated = false;
                }
            }
            this.setMenuItems();

        }).catch(err => console.info(err));
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/patient/' + path]);
    }


    SetTitle(title: string) {
        // this.titleService.setTitle("("+String(this.notifications)+") "+title);
        this.titleService.setTitle(title);

    }

    isRefreshAvialable(): boolean {
        return this.utilitiesService.isRefreshAvialable()
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        await this.utilitiesService.reloadSessionStorage();
        if (!this.isRefreshAvialable()) {

            //this.name = sessionStorage.getItem('name');
            this.email = sessionStorage.getItem('email');
            this.userid = sessionStorage.getItem('userid');


            if (this.userid == null || this.email == null) {
                this.router.navigate(['/' + this.slug + '/notfound']);
                return;
            }
            this.CheckifUserGuidisCorrect(this.userid);

            this.userservice.GetUserData(this.userid).toPromise()
                .then(result => {


                    if (result.success == true) {
                        this.user = result.data;
                        this.name = this.user.first_name + ' ' + this.user.last_name;
                    }
                }).catch(err => console.info(err));;
            this.CheckifMemberExists();

            //server does not work
            //this.Activated=true;
            this.notifications = 1;
            this.SetTitle("Dashboard");

            //this.authservice.data$.subscribe(Activated=>this.Activated=Boolean(Activated));

            //const AccessToken=sessionStorage.getItem('authtoken');
            //const RefreshToken=sessionStorage.getItem('refreshtoken');
            //const email=sessionStorage.getItem('email');
            //const id=sessionStorage.getItem('userid');
            /*if(this.cookieService.get('authtoken')==null || this.cookieService.get('refreshtoken')==null || this.cookieService.get('userid')==null){
                this.router.navigate(['/home']);
            }*/

            /* this.auth.authorize(AccessToken,RefreshToken,email,id).subscribe((result: any)=>{
                    data=result;
    
                    if(data['modified']){
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('email');
                        sessionStorage.removeItem('name');
                        sessionStorage.removeItem('AccessToken');
                        sessionStorage.removeItem('RefreshToken');
                        sessionStorage.removeItem('id');
                        this.router.navigate(['/notfound']);
                    }
                    else{
                        sessionStorage.setItem('AccessToken',data['AccessToken']);
                        sessionStorage.setItem('RefreshToken',data['RefreshToken']);
                    }
    
                })*/
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.rightPanelClick) {
            this.rightPanelActive = false;
        }

        if (!this.megaMenuClick) {
            this.megaMenuActive = false;
        }

        if (!this.usermenuClick && this.isSlim()) {
            this.usermenuActive = false;
            this.activeProfileItem = null;
        }

        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.menuService.reset();
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.menuHoverActive = false;
        }

        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
        this.megaMenuClick = false;
        this.usermenuClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.layoutMode === 'overlay') {
            this.overlayMenuActive = !this.overlayMenuActive;
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;
        event.preventDefault();
    }

    onRightPanelClick() {
        this.rightPanelClick = true;
    }

    onMegaMenuButtonClick(event) {
        this.megaMenuClick = true;
        this.megaMenuActive = !this.megaMenuActive;
        event.preventDefault();
    }

    onMegaMenuClick() {
        this.megaMenuClick = true;
    }

    hideOverlayMenu() {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isHorizontal() {
        return this.layoutMode === 'horizontal';
    }

    isSlim() {
        return this.layoutMode === 'slim';
    }

    isOverlay() {
        return this.layoutMode === 'overlay';
    }

    setMenuItems() {
        const menuItems = [
            {
                label: 'My Dashboard', icon: 'fa fa-fw fa-bar-chart',
                routerLink: [`/${this.slug}/patient/dashboard`], disabled: !this.Activated
            },
            {
                label: 'Consult Doctor',
                routerLink: [`/${this.slug}/patient/consultdoctor`], disabled: !this.Activated,
                icon: 'fa fa-fw fa-user-md',
                styleClass: this.is_uk_country ? '' : 'flash-menu',
            },
            {
                label: 'Upload Medical Details', icon: 'fa fa-fw fa-upload',
                routerLink: [`/${this.slug}/patient/uploadandeditdocuments`], disabled: !this.Activated
            },
            {
                label: 'Track Request', icon: 'fa fa-fw fa-address-card',
                routerLink: [`/${this.slug}/patient/trackrequest`], disabled: !this.Activated
            },
            {
                label: 'Message Center', icon: 'fa fa-fw fa-envelope-open-o',
                routerLink: [`/${this.slug}/patient/messagecenter`], disabled: !this.Activated
            },
            {
                label: 'Doctor Reports', icon: 'fa fa-fw fa-list-alt',
                routerLink: [`/${this.slug}/patient/doctorreports`], disabled: !this.Activated
            },
            {
                label: 'Add New Members', icon: 'fa fa-fw fa-user-plus',
                routerLink: [`/${this.slug}/patient/members/add`],
            },
            {
                label: 'Registered Members', icon: 'fa fa-fw fa-user-plus',
                routerLink: [`/${this.slug}/patient/activatedmembers`],
            },
            {
                label: 'Transactions', icon: 'fa fa-fw fa-credit-card',
                routerLink: [`/${this.slug}/patient/transactions`], disabled: !this.Activated
            },
            {
                label: 'Sign Out', icon: 'fa fa-fw fa-power-off',
                routerLink: [`/${this.slug}/logout`]
            }
        ];

        if (this.is_primary_provider) {
            menuItems.splice(7, 0, {
                label: 'Health Passport', icon: 'pi pi-copy',
                routerLink: [`/${this.slug}/patient/health-passport`], disabled: !this.Activated
            })

        }

        if (this.is_primary_provider && !this.is_uk_country) {
            menuItems.splice(3, 0, {
                label: 'Packages', icon: 'pi pi-briefcase',
                routerLink: [`/${this.slug}/patient/packages`], disabled: !this.Activated,
                styleClass: this.is_uk_country ? '' : 'flash-menu',
            }),
                menuItems.splice(4, 0, {
                    label: 'Diet Plans', icon: 'pi pi-briefcase',
                    routerLink: [`/${this.slug}/patient/nutrition-and-health`], disabled: !this.Activated
                }),
                menuItems.splice(8, 0, {
                    label: 'Discount Coupons', icon: 'fa fa-fw fa-money',
                    routerLink: [`/${this.slug}/patient/couponcode`], disabled: !this.Activated
                })
        }

        this.menuService.setItems(menuItems);
    }
}
